/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weighing_SaveInputs */

const vi_weighing_save = /** @type {(inputs: Weighing_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu phiếu cân`)
};

/**

* @param {Weighing_SaveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const weighing_save = /** @type {((inputs?: Weighing_SaveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weighing_SaveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_weighing_save(inputs)
});